export default "__VITE_ASSET__wzeaF1W9__"